<template>
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1_4286)">
            <path d="M10.9792 10.4167H10.4196L10.2213 10.2254C10.9154 9.41792 11.3333 8.36958 11.3333 7.22917C11.3333 4.68625 9.27208 2.625 6.72917 2.625C4.18625 2.625 2.125 4.68625 2.125 7.22917C2.125 9.77208 4.18625 11.8333 6.72917 11.8333C7.86958 11.8333 8.91792 11.4154 9.72542 10.7213L9.91667 10.9196V11.4792L13.4583 15.0138L14.5138 13.9583L10.9792 10.4167ZM6.72917 10.4167C4.96542 10.4167 3.54167 8.99292 3.54167 7.22917C3.54167 5.46542 4.96542 4.04167 6.72917 4.04167C8.49292 4.04167 9.91667 5.46542 9.91667 7.22917C9.91667 8.99292 8.49292 10.4167 6.72917 10.4167Z" fill="#323232"/>
        </g>
        <defs>
            <clipPath id="clip0_1_4286">
                <rect width="17" height="17" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
        </defs>
    </svg>
</template>
